import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

export function useShowMenu() {
  const location = useLocation();

  const [showMenu, setShowMenu] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 1024) {
      setShowMenu(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const query = window.matchMedia('(max-width: 1024px)');

    function listener(event: MediaQueryListEvent) {
      setShowMenu(!event.matches);
    }

    query.addEventListener('change', listener);

    return () => query.removeEventListener('change', listener);
  }, []);

  return { showMenu, setShowMenu };
}
